import {
  AccessDeniedError,
  BadRequestError,
  ConnectionError,
  HttpTypes,
  InternalServerError,
  TooManyRequestsError,
  UnexpectedError,
} from 'src/http';
import { httpResponseHandler } from 'src/http/http-response-handler';
import { fileUploadType } from 'src/types/banners';
import { homeBandItem } from 'src/types/home-band';
import { endpoints } from 'src/utils/axios';
import { Either } from 'src/utils/either';

export default class HomeBandsRepository {
  constructor(private api: HttpTypes.HttpClient) {}

  async findAllBands(): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.personalization.homeBands.list,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async findOne(
    id: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.personalization.homeBands.one,
      params: { bandId: id },
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async update(
    id: string,
    data: homeBandItem
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: endpoints.personalization.homeBands.edit,
      params: { id },
      body: data,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async create(
    data: homeBandItem
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.personalization.homeBands.create,
      body: data,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async uploadFile(
    file: fileUploadType
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.files.upload,
      body: { ...file, optimizateImage: true },
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }
}
